import VoucherTabs from './VoucherTabs'

export default VoucherTabs
